import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { BatchMovementDto, Paginated, StockGroupDto, StockPlaceDto } from '@eombor/contracts';
import { stockApi, type StockSearchQuery } from '../api/stock.api.js';

/**
 * Qoldiq so'rovlari bitta joyda: kalitlar ham shu yerda turadi, shuning uchun
 * kirim yoki ko'chirishdan keyin `invalidateQueries({ queryKey: stockKeys.all })`
 * qidiruvni ham, katak panelini ham bir xil yangilaydi.
 */
export const stockKeys = {
  all: ['stock'] as const,
  search: (query: StockSearchQuery) => ['stock', 'search', query] as const,
  byCell: (cellId: string | null) => ['stock', 'by-cell', cellId] as const,
  movements: (batchId: string | null) => ['stock', 'movements', batchId] as const,
};

export const useStockSearch = (
  query: StockSearchQuery = {},
  /** `false` — so'rov yuborilmaydi (masalan oynada boshqa qadam ochiq). */
  enabled = true,
): UseQueryResult<Paginated<StockGroupDto>> =>
  useQuery({
    queryKey: stockKeys.search(query),
    queryFn: () => stockApi.search(query),
    enabled,
  });

/** Katak ichidagi partiyalar — katak kartochkasi shundan chiziladi. */
export const useStockByCell = (cellId: string | null): UseQueryResult<StockPlaceDto[]> =>
  useQuery({
    queryKey: stockKeys.byCell(cellId),
    queryFn: () => stockApi.byCell(cellId ?? ''),
    enabled: cellId !== null,
  });

/** Tarix faqat oyna OCHILGANDA so'raladi — har katak tanlashda emas. */
export const useBatchMovements = (batchId: string | null): UseQueryResult<BatchMovementDto[]> =>
  useQuery({
    queryKey: stockKeys.movements(batchId),
    queryFn: () => stockApi.movements(batchId ?? ''),
    enabled: batchId !== null,
  });
